<template>
  <Modal v-if="showLoadingModal" @close="$emit('close-loading-modal')">
    <div v-show="!completed && !failed">
      <p class="text">
        {{ $t('pages.CompaniesStorePost.loadingModal.loading') }}
      </p>

      <Loading />
    </div>

    <div v-show="completed" class="completed">
      <p class="text">
        {{ $t('pages.CompaniesStorePost.loadingModal.completed') }}
      </p>
    </div>

    <div v-show="failed" class="completed">
      <p class="text">
        {{ $t('pages.CompaniesStorePost.loadingModal.failed') }}
      </p>
    </div>
  </Modal>
</template>

<script>
import Modal from '../Modal.vue'
import Loading from '../Loading.vue'

export default {
  name: 'LoadingModal',
  components: {
    Modal,
    Loading,
  },
  props: {
    showLoadingModal: Boolean,
    completed: Boolean,
    failed: Boolean,
  },
  emits: ['close-loading-modal'],
}
</script>

<style lang="scss" scoped>
.text {
  padding-top: 48px;
  text-align: center;
  font-weight: bold;
  white-space: pre-line;
}

.completed .text {
  padding: 48px 0;
}

</style>
